
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ComponentDocs, Preview } from "@lighting-beetle/lighter-styleguide";
import { Checkbox, Fieldset, RadioCheckGroup } from "..";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Fieldset`}</h1>
    <h2>{`Example`}</h2>
    <Fieldset legend="Legend Caption" mdxType="Fieldset">
  <RadioCheckGroup mdxType="RadioCheckGroup">
    <Checkbox name="fieldset-example" id="fieldset-example-1" mdxType="Checkbox">
      Checkbox 1
    </Checkbox>
    <Checkbox name="fieldset-example" id="fieldset-example-2" mdxType="Checkbox">
      Checkbox 2
    </Checkbox>
    <Checkbox name="fieldset-example" id="fieldset-example-3" mdxType="Checkbox">
      Checkbox 3
    </Checkbox>
  </RadioCheckGroup>
    </Fieldset>
    <h2>{`Variants`}</h2>
    <h3>{`Basic`}</h3>
    <Preview mdxType="Preview">
  <Fieldset legend="Legend Caption" mdxType="Fieldset">
    <RadioCheckGroup mdxType="RadioCheckGroup">
      <Checkbox name="fieldset-basic" id="fieldset-basic-1" mdxType="Checkbox">
        Checkbox 1
      </Checkbox>
      <Checkbox name="fieldset-basic" id="fieldset-basic-2" mdxType="Checkbox">
        Checkbox 2
      </Checkbox>
      <Checkbox name="fieldset-basic" id="fieldset-basic-3" mdxType="Checkbox">
        Checkbox 3
      </Checkbox>
    </RadioCheckGroup>
  </Fieldset>
    </Preview>
    <h3>{`Visually hidden legend caption`}</h3>
    <Preview mdxType="Preview">
  <Fieldset legend="Hidden Legend Caption" hideLegend mdxType="Fieldset">
    <RadioCheckGroup mdxType="RadioCheckGroup">
      <Checkbox name="fieldset-hidden-legend" id="fieldset-hidden-legend-1" mdxType="Checkbox">
        Checkbox 1
      </Checkbox>
      <Checkbox name="fieldset-hidden-legend" id="fieldset-hidden-legend-2" mdxType="Checkbox">
        Checkbox 2
      </Checkbox>
      <Checkbox name="fieldset-hidden-legend" id="fieldset-hidden-legend-3" mdxType="Checkbox">
        Checkbox 3
      </Checkbox>
    </RadioCheckGroup>
  </Fieldset>
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<Fieldset />" component={Fieldset} mdxType="ComponentDocs" />
    <h2>{`Accessibility`}</h2>
    <p>{`Fieldsets group inputs into logic parts of a form. A screenreader usually announces the filedset legend along with the label of each nested input, which helps users stay in context when tabbing through different inputs within a fieldset. For example a color switch would consist of radio buttons wrapped in a fieldset, with a legend reading "Color". A screenreader would then read each input's label prefixed with the legend contnets (e.g. Color blue, color red, color green...).`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;